module.exports = __webpack_public_path__ + "static/media/clue-1.30d3b09c.svg";